import { map } from 'rxjs';
import { BackupSystemsAPI } from '@imunify360-api/backup-systems';
import { Injectable } from '@angular/core';
import { cache } from 'app/utils/cache';
import { XHR } from 'app/utils/xhr/xhr';


@Injectable()
export class BackupSystemsService {
    // extended-status!
    status = this.xhr.rx(BackupSystemsAPI.status);
    // just status actually
    narrowStatus = this.xhr.rx(BackupSystemsAPI.narrowStatus);
    list = this.xhr.rx(BackupSystemsAPI.list);
    disable = this.xhr.rx(BackupSystemsAPI.disable);
    disableCloudlinux = this.xhr.rx(BackupSystemsAPI.disableCloudlinux);
    checkCloudlinux = this.xhr.rx(BackupSystemsAPI.checkCloudlinux);
    init = this.xhr.rx(BackupSystemsAPI.init);

    backupsEnabled = this.narrowStatus().pipe(
        cache(5),
        map(res => res.data.items && res.data.items.enabled),
    );

    constructor(
        public xhr: XHR,
    ) {}
}
